<template>
  <content-page kind="category"/>
</template>
<script>import ContentPage from './content-page';

export default {components: {ContentPage}}</script>
